import styled from 'styled-components';

export const MainContainer = styled.div`
  padding: 0px 50px 50px;
  display: flex;
  position: relative;
  text-align: center;
  overflow: hidden;
  height: 70vh;
  background-color: #fffcf5;
  @media (max-width: 768px) {
    padding: 20px 20px 40%;
    height: auto;
    display: ${(props) => (props.isAboutUsPage ? 'none' : '')};
  }
  align-items: center;
  h2 {
    font-size: clamp(20px, 2vw, 36px);
    margin-bottom: 2%;
    color: rgba(0, 0, 0, 0.7);
  }
  img {
    margin-bottom: 5%;
    @media (max-width: 768px) {
      width: 80px;
    }
  }
  h3 {
    font-size: clamp(30px, 2vw, 48px);
    margin-bottom: 10%;
    @media (max-width: 768px) {
      margin-bottom: 40px;
    }
    opacity: 0.6;
  }
  .brands {
    margin: auto;
    width: 100%;
    margin-top: 3%;
    padding: 20px 0px;

    border: 2px solid rgba(0, 0, 0, 0.4);
    border-radius: 1.5rem;
    color: rgba(0, 0, 0, 0.7);
    @media (max-width: 768px) {
      display: flex;
      align-items: center;
      padding: 10px 0px;
    }
  }
  p {
    font-weight: 500;
    font-size: clamp(16px, 2vw, 20px);
    padding: 20px 0;
  }
  a {
    font-size: 13px;
    padding: 10px;
    border-right: 2px solid rgba(0, 0, 0, 0.4);
    font-weight: 600;
  }
  a:last-child {
    border-right: none;
  }
  .bgWave {
    display: none;
    @media (min-width: 768px) {
      position: absolute;
      inset: 0;
      z-index: 1;
      height: auto;
      width: 100%;
      display: block;
      aspect-ratio: 2;
      top: 20%;
    }
  }
  .bgWaveMobile {
    @media (min-width: 768px) {
      display: none;
    }
    position: absolute;
    inset: 0;
    // z-index: 1;
    height: auto;
    width: 100%;
    top: 40%;
  }
  .myloInfo {
    position: relative;
    z-index: 2;
    left: 50%;
    transform: translateX(-50%);
  }
`;
